module.exports = __webpack_public_path__ + "img/9_11.39b97e52.png";